import React from "react";
import { useDispatch } from "react-redux";

//import MUI
import { Modal } from "antd";
import Avatar from "@mui/material/Avatar";

// form elements

// import TextField from "../formElement/TextField";
import NumberField from "../formElement/NumberField";
import Autocomplete from "../formElement/Autocomplete";

// API
import DesignCatApi from "../../api/common/DesignCat";
import { setIsLoading } from "../../redux/reducers/page";

const orderByOpt = [
  {
    value: "position",
    label: "جدیدترین",
  },
  {
    value: "visitCount",
    label: "پربادید ترین",
  },
  {
    value: "likes",
    label: "محبوب ترین",
  },
  {
    value: "purchasCount",
    label: "پرفروش ترین",
  },
];
const orderByO = {
  position: "جدیدترین",
  visitCount: "پربادید ترین",
  likes: "محبوب ترین",
  purchasCount: "پرفروش ترین",
};

const Search = (props) => {
  // redux
  const dispatch = useDispatch();
  const [designCat2, setDesignCat2] = React.useState([]);
  const {
    setCat1,
    cat1,
    setCat2,
    cat2,
    setTitle,
    setId,
    title,
    orderBy,
    setOrderBy,
    findDesigns,
    rootDesignCats,
    setFilters,
    cat2List,
    setCat2List,
  } = props.items;
  const { openModal, setOpenModal } = props;
  setTitle(null);
  const setCat = async (designCat) => {
    if (designCat.id) {
      dispatch(setIsLoading(true));
      setCat1(designCat);
      const designCats = await DesignCatApi(designCat.id);
      const opts = designCats.data.map((designCat) => {
        return {
          id: designCat.id,
          title: designCat.title,
          description: designCat.description,
          mediaUrl: designCat.Media.mediaUrl,
        };
      });
      setDesignCat2(opts);
      setCat2List(true);
      dispatch(setIsLoading(false));
    }
  };

  const submitForm = () => {
    const filterArr = [];
    if (cat1) filterArr.push({ text: cat1.title, type: "cat1" });
    if (cat2) filterArr.push({ text: cat2.title, type: "cat2" });
    if (title) filterArr.push({ text: title, type: "title" });
    if (orderBy) filterArr.push({ text: orderByO[orderBy], type: "orderBy" });
    setFilters([...new Set(filterArr)]);
    findDesigns();
    setOpenModal(false);
  };
  return (
    <Modal
      title="جستجوی طرح"
      centered
      open={openModal}
      onOk={() => submitForm()}
      onCancel={() => setOpenModal(false)}
      okText={"تایید"}
      cancelText="انصراف"
    >
      <div className="col-12">
        <hr className="p-0 mb-2" />
        <div className="row mt-1">
          <div className="col-12 p-0 ">
            <div className="row  justify-content-center">
              {cat2List
                ? designCat2.map((item, index) => {
                    return (
                      <div
                        tabindex={index}
                        key={index}
                        className="col-4 text-center pointer designCat2"
                        onClick={() => setCat2(item)}
                      >
                        <div className="row justify-content-center">
                          <div className="col-md-4 col-6 p-0 m-0">
                            <Avatar
                              alt={item.title}
                              src={item.mediaUrl}
                              sx={{
                                width: 50,
                                height: 50,
                                textAlign: "center",
                              }}
                            />
                          </div>
                        </div>
                        {item.title}
                      </div>
                    );
                  })
                : rootDesignCats.map((item, index) => {
                    return (
                      <div
                        key={index}
                        className="col-4 text-center pointer"
                        onClick={() => setCat(item)}
                      >
                        <div className="row justify-content-center">
                          <div className="col-md-4 col-6 p-0 m-0">
                            <Avatar
                              alt={item.title}
                              src={item.mediaUrl}
                              sx={{
                                width: 50,
                                height: 50,
                                textAlign: "center",
                              }}
                            />
                          </div>
                        </div>

                        {item.title}
                      </div>
                    );
                  })}
            </div>
          </div>
          {/* <div className="col-12 p-0 ">
            <TextField
              required={false}
              defaultValue={title}
              name="title"
              label="عنوان طرح"
              type="text"
              onChange={(e) => {
                setTitle(e.target.value);
              }}
            />
          </div> */}
          <div className="col-12 p-0 ">
            <NumberField
              required={false}
              defaultValue={title}
              name="id"
              label="کد طرح"
              type="number"
              onChange={(e) => {
                setId(e.target.value);
              }}
            />
          </div>

          <div className="col-12 p-0 ">
            <Autocomplete
              options={orderByOpt}
              defaultValue={null}
              name="proDist"
              label="مرتب سازی "
              setValue={setOrderBy}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};
export default Search;
